// extracted by mini-css-extract-plugin
export var modal = "_de-0";